import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
import { BookingServiceProvider } from '../../providers/booking-service/booking-service';

@Component({
  selector: 'app-booking-details',
  templateUrl: 'booking-details.html',
})
export class BookingDetails {
  booking: any;
  barber: any;
  currencySymbol: string;

  constructor(private navParams: NavParams, private viewCtrl: ViewController, public bookingProvider: BookingServiceProvider) {
    this.booking = this.navParams.get('booking');    
    this.barber = this.navParams.get('barber');
    this.currencySymbol = this.navParams.get('currencySymbol');
  }
  calculateTotalDuration(booking){
    return booking.services.reduce((total, service) => total + service.service.service.duration * service.quantity, 0);
  }  

  amountPaid(booking) {
    return this.bookingProvider.getAmountPaid(booking);
  }

  amountDue(booking) {
    return this.bookingProvider.getAmountDue(booking);
  }

  getTimeUrl(): string {
    return './assets/icon/history_clock.svg'; // Replace with actual time icon
  }

  closeModal() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/booking-details/booking-details.ts